import React from "react";
import './Loading.css';

// TODO: This is pretty big, so make it smaller
// TODO: Fade in after ~100ms or something, so it doesn't flash on open
export default function Loading({ children, loading }) {
    if (loading) {
        return (
            <div className="loading" style={ { textAlign: 'center' } } />
        )
    }

    return children;
}